
import { API, GET, randomString } from '../helpers'

export const getMeetDetailsFunc = params => {
    return new Promise((resolve, reject) => {
        const url = API.MEET_DETAILS_GET + params.meetId;
        GET(url, {}, {}, {}, true, false, params.eventId
        ).then(({ status, result, message }) => {
            if (status === "success") {
                let meet = {
                    user: {
                        avatar: result.user && result.user.avatar ? result.user.avatar : null,
                        email: result.user && result.user.email ? result.user.email : null,
                        jwt: result.user && result.user.jwt ? result.user.jwt : null,
                        role: result.user && result.user.role ? result.user.role : null,
                    },
                    details: {
                        id: result.meet && result.meet.id ? result.meet.id : null,
                        title: result.meet && result.meet.title ? result.meet.title : null,
                        description: result.meet && result.meet.description ? result.meet.description : null,
                        domain: result.jitsiUrl ? result.jitsiUrl.replace(/^https?:\/\//, '') : null,
                        roomId: result.meet.roomId ? result.meet.roomId : null,
                        startTime: result.meet.startTime ? result.meet.startTime : null,
                        endTime: result.meet.endTime ? result.meet.endTime : null,
                        meetLimit: result.meetLimit ? result.meetLimit : null,
                        isMeetExpired: result.isMeetExpired,
                    },
                    regions: result.regions ? result.regions : [{
                        name: "Canada(Central)",
                        code: "ca-central-1",
                        pingUrl: "https://ec2.ca-central-1.amazonaws.com/ping",
                    }],
                    setting: ['hangup', 'settings', 'videoquality', 'fullscreen', 'filmstrip', 'tileview'],
                    config: {
                        remoteVideoMenu: {
                            disableKick: false
                        },
                        startWithAudioMuted: false,
                        startWithVideoMuted: true,
                        deploymentInfo: {},
                        makeJsonParserHappy: 'even if last key had a trailing comma'
                    }
                };

                if (meet.user.role === 'MODERATOR') {
                    meet.setting.push('desktop', 'mute-everyone', 'microphone', 'camera', 'closedcaptions', 'livestreaming', 'recording', 'sharedvideo');
                } else if (meet.user.role === 'PRESENTER') {
                    meet.setting.push('desktop', 'microphone', 'camera', 'closedcaptions', 'sharedvideo');
                }
                else {
                    meet.config = {
                        remoteVideoMenu: {
                            disableKick: true
                        },
                        startWithAudioMuted: true,
                        startWithVideoMuted: true,
                        deploymentInfo: {},
                    }
                }

                resolve({ status, data: meet, message });
            } else if (status === "error") {
                reject({ status: "error", message: message });
            }
        })
            .catch(function (error) {
                reject(error);
            });
    });
};

export const checkLatency = (url, region) => {
    return new Promise((resolve, reject) => {
        var startTime = Date.now();
        GET(url + '?cache_buster=' + randomString(15), {}, {}, {}, false, true, null, null,
        )
            .then((apiResult) => {
                var endTime = Date.now();
                var timeElapsed = endTime - startTime;
                resolve({ timeElapsed, region });
            })
            .catch(function (error) {
                var endTime = Date.now();
                var timeElapsed = endTime - startTime;
                resolve({ timeElapsed, region });
            });
    });
};